import { render, staticRenderFns } from "./ShortCutsModal.vue?vue&type=template&id=25798d86&"
import script from "./ShortCutsModal.vue?vue&type=script&lang=js&"
export * from "./ShortCutsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports